module.exports = __webpack_public_path__ + "assets/img/carousel_1.f680b3e1.png";